// extracted by mini-css-extract-plugin
export default {"headlineSection":"Headline_headlineSection__69aE2","headline":"Headline_headline__11vhj","text":"Headline_text__3wv5Y"};